/* import __COLOCATED_TEMPLATE__ from './about.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './about.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteAbout extends Component {}
